<template lang="pug">
.quantity-input
  button.quantity-input__decrement(@click.prevent.stop="decrement" label="Decrease Quantity" :aria-label="`Decrease Quantity by 1`")
    icon(name="minus" size="16px")
  label(for="quantity" class="hidden" aria-hidden="true") Quantity
  input.quantity-input__text(
    id="quantity"
    name="quantity"
    :value="quantity"
    type="text"
    :min="min"
    :max="max"
    :aria-label="`Quantity ${currentValue}`"
    aria-live="polite"
    readonly)
  button.quantity-input__increment(@click.prevent.stop="increment" label="Increase Quantity" :aria-label="`Increase Quantity by 1`")
    icon(name="plus" size="16px")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'QuantityInput',
    components: { Icon },
    props: {
      item: Object,
      quantity: Number,
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: 100
      },
    },
    data() {
      return {
        currentValue: this.quantity
      }
    },
    methods: {
      increment() {
        if (this.currentValue < this.max) this.currentValue++
        this.$emit('update:quantity', this.currentValue)
      },
      decrement() {
        if (this.currentValue > this.min) this.currentValue--
        this.$emit('update:quantity', this.currentValue)
      }
    }
  };
</script>

<style scoped lang="scss">
  .quantity-input {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
  }
  .quantity-input__increment,
  .quantity-input__decrement {
    position: absolute;
    top: 0;
    width: 40px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    min-width: 0;
    padding: 0;
    border: none;
    .icon {
      color: $color-black;
    }
  }
  .quantity-input__increment {
    right: 0;
  }
  .quantity-input__decrement {
    left: 0;
  }
  input[type='text'].quantity-input__text {
    border: 0 !important;
    outline: 0 !important;
    font-weight: $font-weight-bold;
    text-align: center;
  }
</style>
